import StatusIndicator from './components/StatusIndicator'
import { Transaction } from 'graphql'
import styles from './status.module.css'

function render( _: string, transaction: Transaction ) {
	return (
		<div className={styles.status}>
			<StatusIndicator
				transaction={transaction}
			/>
		</div>
	)
}

export default {
	field: 'status',
	name: 'Status',
	width: '172px',
	render,
}
